import { render, staticRenderFns } from "./linkedin.vue?vue&type=template&id=66ea7673&"
import script from "./linkedin.vue?vue&type=script&lang=js&"
export * from "./linkedin.vue?vue&type=script&lang=js&"
import style0 from "./linkedin.vue?vue&type=style&index=0&id=66ea7673&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports